/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

function DialogActions(props) {
    const { children, className, ...other } = props;

    return (
        <div className={className} {...other}>
            {children}
        </div>
    );
}

DialogActions.propTypes = {
    children: PropTypes.node.isRequired,
    /**
   * @ignore
   */
    className: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const DialogActions = ({prop = val, className = '' }) =>

export default memo(DialogActions);
